import * as THREE from "three";
import {CSS3DRenderer} from "three/examples/jsm/renderers/CSS3DRenderer";

export function createRenderer(width,height) {
    const renderer = new THREE.WebGLRenderer({
        alpha: true,
        logarithmicDepthBuffer: true, //解决模型重合相交部分闪烁 Z-Fighting
    });
    renderer.setSize(width, height);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.setClearColor(0x000000,0);
    return renderer;
}

export function createLabelRenderer(width, height) {
    const renderer = new CSS3DRenderer();
    renderer.setSize(width, height);
    renderer.domElement.style.position = 'absolute';
    renderer.domElement.style.top = '0px';
    renderer.domElement.style.left = '0px';
    //设置.pointerEvents=none，以免模型标签HTML元素遮挡鼠标选择场景模型
    renderer.domElement.style.pointerEvents = 'none';
    return renderer;
}
